import type { ReactNode } from 'react';
import { strokesToParDelta } from '../utils/format';

type Props = {
  holeNumber: number;
  par: number;
  strokes: number | null;
  onChange: (next: number) => void;
  disabled?: boolean;
  sideButtons?: ReactNode;
};

export function HoleStepper({ holeNumber, par, strokes, onChange, disabled, sideButtons }: Props) {
  const isUnsaved = strokes === null;
  const baseline = strokes ?? 0;
  const delta = strokesToParDelta(par, strokes);

  return (
    <div className="card row" style={{ justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
      <div className="row" style={{ gap: 12, flexWrap: 'wrap', flex: 1, minWidth: 0 }}>
        <div>
          <div style={{ fontWeight: 700 }}>Hole {holeNumber}</div>
          <div className="muted" style={{ fontSize: 12 }}>Par {par}</div>
        </div>
        {sideButtons && (
          <div className="row" style={{ gap: 6, flexWrap: 'wrap' }}>
            {sideButtons}
          </div>
        )}
      </div>
      <div className="row" style={{ gap: 8 }}>
        <button
          type="button"
          disabled={disabled || baseline <= 1}
          onClick={() => onChange(Math.max(1, baseline - 1))}
          style={{ width: 44, height: 44, borderRadius: 22, border: '1px solid var(--border)', background: 'var(--bg-surface)', fontSize: 22, cursor: 'pointer' }}
        >
          −
        </button>
        <div
          title={isUnsaved ? 'Tap + to enter strokes.' : undefined}
          style={{ minWidth: 40, textAlign: 'center', fontSize: 24, fontWeight: 700, opacity: isUnsaved ? 0.45 : 1 }}
        >
          {baseline}
        </div>
        <button
          type="button"
          disabled={disabled || baseline >= 20}
          onClick={() => onChange(Math.min(20, baseline + 1))}
          style={{ width: 44, height: 44, borderRadius: 22, border: '1px solid var(--color-green-700)', background: 'var(--color-green-700)', color: 'white', fontSize: 22, cursor: 'pointer' }}
        >
          +
        </button>
        <span className={delta.className} title={`${strokes ?? '-'} vs par ${par}`}>{isUnsaved ? '' : delta.label}</span>
      </div>
    </div>
  );
}
